module.exports = __webpack_public_path__ + "assets/img/picture7.e4d80b73.svg";